module.exports = __webpack_public_path__ + "img/winner.21aec026.svg";